import Axios from "axios";
import store from "@/store";

export async function loginRequest({ phone, password }) {
  return Axios.post("/auth/login/", {
    phone,
    password,
  });
}

export async function captchaRequest({ phone }) {
  return Axios.post("/captcha/", {
    phone,
  });
}

export async function checkRegistrationCodeRequest({ temp_token, code }) {
  return Axios.post("/auth/check-registration-code/", {
    temp_token,
    code,
  });
}

export async function passwordResetConfirmRequest({
  temp_token,
  code,
  password,
  screen_id,
}) {
  const body = {
    temp_token,
    code,
    password,
  };
  // Пустой screen_id не шлём: legacy-код остаётся на прежнем confirm
  if (screen_id) {
    body.screen_id = screen_id;
  }
  return Axios.post("/auth/password-reset-confirm/", body);
}

export async function passwordResetRequest({
  phone,
  code_type,
  supports_max_hybrid,
}) {
  const body = { phone, code_type };
  // Только JSON true: omit и false оставляют старый SMS-путь (D-186)
  if (supports_max_hybrid === true) {
    body.supports_max_hybrid = true;
  }
  return Axios.post("/auth/password-reset/", body);
}

export async function passwordResetStatusRequest({ temp_token, poll_key }) {
  return Axios.get("/auth/password-reset/status/", {
    params: {
      temp_token,
      poll_key,
    },
  });
}

export async function passwordResetCancelRequest({ temp_token, poll_key }) {
  return Axios.post("/auth/password-reset/cancel/", {
    temp_token,
    poll_key,
  });
}

export async function passwordResetSendCodeRequest({ temp_token, poll_key }) {
  return Axios.post("/auth/password-reset/send-code/", {
    temp_token,
    poll_key,
  });
}

export async function passwordResetLinkRequest(code) {
  return Axios.get("/auth/password-reset/link/", {
    params: {
      code,
    },
  });
}

export function refreshTokenRequest({ refresh }) {
  return Axios.post("/auth/refresh-token/", { refresh });
}

export async function registrationRequest({
  phone,
  password,
  temp_token,
  code,
  captcha,
  supports_max_hybrid,
}) {
  const sessionId = store.getters.getRegistrationSessionId;
  const body = {
    phone,
    password,
    temp_token,
    code,
  };
  if (captcha !== undefined && captcha !== null && captcha !== "") {
    body.captcha = captcha;
  }
  // Только JSON true доходит до wire — omit/false не оптят старые вызовы в hybrid
  if (supports_max_hybrid === true) {
    body.supports_max_hybrid = true;
  }
  return Axios.post("/auth/registration/", body, {
    params: {
      registration_session_id: sessionId,
    },
  });
}

export async function registrationByAccountRequest({
  object_id,
  object_uuid,
  account,
  phone,
  code_type,
}) {
  return Axios.post("/auth/registration/by-account/", {
    object_id,
    object_uuid,
    account,
    phone,
    code_type,
  });
}

export async function registrationByPhoneRequest({ phone, code_type }) {
  return Axios.post("/auth/registration/by-phone/", { phone, code_type });
}

export async function registrationCompleteRequest({ temp_token, password }) {
  return Axios.post("/auth/registration/complete/", { temp_token, password });
}

export async function registrationConfirmRegistrationCodeRequest({
  temp_token,
  code,
}) {
  const sessionId = store.getters.getRegistrationSessionId;
  return Axios.post(
    "/auth/registration/confirm/",
    {
      temp_token,
      code,
    },
    {
      params: {
        registration_session_id: sessionId,
      },
    },
  );
}

export async function registrationSendConfirmationCodeRequest({ phone }) {
  return Axios.post("/auth/registration/send-confirmation-code/", {
    phone,
    code_type: "phone_numbers",
  });
}

export async function registrationStatusRequest({ temp_token, bind_token }) {
  return Axios.get("/auth/registration/status/", {
    params: {
      temp_token,
      bind_token,
    },
  });
}

export async function logoutRequest({ userId }) {
  return Axios.post(`users/${userId}/logout/`);
}

export async function saveUserAgreementRequest(agreementsArray) {
  const sessionId = store.getters.getRegistrationSessionId;
  return Axios.post("/agreements/", agreementsArray, {
    withCredentials: true,
    params: {
      registration_session_id: sessionId,
    },
  });
}

export async function maxHybridFlagRequest() {
  return Axios.get("/auth/max-hybrid/");
}

export async function maxLoginStartRequest({
  replace_login_token,
  replace_poll_key,
} = {}) {
  const body = {};
  // Replace только парой: телефон и пароль на этот путь не отправляем (D-136)
  if (replace_login_token && replace_poll_key) {
    body.replace_login_token = replace_login_token;
    body.replace_poll_key = replace_poll_key;
  }
  return Axios.post("/auth/login/max/", body);
}

export async function maxLoginStatusRequest({ login_token, poll_key }) {
  return Axios.get("/auth/login/max/status/", {
    params: {
      login_token,
      poll_key,
    },
  });
}

export async function maxLoginCancelRequest({ login_token, poll_key }) {
  return Axios.post("/auth/login/max/cancel/", {
    login_token,
    poll_key,
  });
}

export async function maxLoginExchangeRequest({ exchange_code }) {
  return Axios.post("/auth/login/max/exchange/", {
    exchange_code,
  });
}

export function maxLoginCancelBeaconUrl({ login_token, poll_key }) {
  const base = String(Axios.defaults.baseURL || "").replace(/\/+$/, "");
  return `${base}/auth/login/max/cancel/?login_token=${encodeURIComponent(
    login_token,
  )}&poll_key=${encodeURIComponent(poll_key)}`;
}
